import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UserLoginService } from 'src/app/login/userlogin.service';
import { PropertyVisitCreateRequestDTO, PropertyVisitDeleteRequestDTO, PropertyVisitDTO, PropertyVisitUpdateRequestDTO } from 'src/app/real-estate/Interface & Service/property-visit/propertyVisit.interface';
import { PropertyVisitService } from 'src/app/real-estate/Interface & Service/property-visit/propertyVisit.service';
import { ConfirmmodalserviceService } from 'src/app/Shared Utilities/confirm-delete-modal/confirmdeletemodal.service';
import { formatDateForInput } from 'src/app/Shared Utilities/CustomFunctions/CustomFunctions';
import Swal from 'sweetalert2';


interface DateTab {
  day: string;
  dateNum: string;
  month: string;
  date: Date;
}

@Component({
  selector: 'app-schedule-visit',
  templateUrl: './schedule-visit.component.html',
  styleUrls: ['./schedule-visit.component.css'],
})


export class ScheduleVisitComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private propertyVisitService = inject(PropertyVisitService);
  private User = inject(UserLoginService).User();
  private route = inject(ActivatedRoute);
  private toastr = inject(ToastrService);
  private confirmationModalService = inject(ConfirmmodalserviceService);
  @ViewChild('dateInput') dateInput!: ElementRef;

  propertyId: number = 0;
  scheduleVisitData: PropertyVisitDTO | null = null;
  dateTabs: DateTab[] = [];
  minDate: string | null = null;
  maxDate: string | null = null;
  selectedDate: Date = new Date();


  selectedSlot: string | null = null;
  morningSlots: string[] = ['10:00AM', '10:30AM', '11:00AM', '11:30AM'];
  afternoonSlots: string[] = ['12:00PM', '12:30PM', '01:00PM', '01:30PM', '02:00PM', '02:30PM', '03:00PM', '03:30PM', '04:00PM', '04:30PM'];
  eveningSlots: string[] = ['05:00PM', '05:30PM', '06:00PM', '06:30PM', '07:00PM', '07:30PM', '08:00PM', '08:30PM', '09:00PM', '09:30PM'];

  showRescheduleConfirmation = false;

  ngOnInit(): void {

    const today = new Date();
    this.minDate = formatDateForInput(today);

    const max = new Date(today); // clone today
    max.setDate(max.getDate() + 10); // add 10 days
    this.maxDate = formatDateForInput(max);

    if (this.scheduleVisitData) {
      this.showRescheduleConfirmation = true; // Show reschedule confirmation UI first
      this.selectedSlot = this.scheduleVisitData.timeSlot;
      this.selectedDate = new Date(this.scheduleVisitData.scheduledDate);
      this.generateDateTabs(this.selectedDate, true);
    } else {
      this.generateDateTabs(new Date());
    }

  }

  proceedToReschedule() {
    this.showRescheduleConfirmation = false;
  }

  close() {
    this.activeModal.dismiss();
  }

  cancelScheduleVisit() {
    const visit = this.scheduleVisitData;
    if (!visit) return;

    const date = new Date(visit.scheduledDate);
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    };
    const formattedDate = date.toLocaleDateString('en-US', options); // e.g., 22 March 2026

    const time = visit.timeSlot; // function defined below

    const message = `your visit for ${formattedDate} at ${time}`;

    this.confirmationModalService.openDeleteModal(message, visit).subscribe((res) => {
      if (res) {
        const data: PropertyVisitDeleteRequestDTO = {
          visitId: visit.visitId,
          actionUser: this.User.userId.toString()
        };

        this.propertyVisitService.PropertyVist_Delete(data).subscribe(() => {
          this.scheduleVisitData = null;
        });
      }
    });
  }

  generateDateTabs(date: Date, centerDate: boolean = false) {
    this.dateTabs = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const maxDate = new Date(today);
    maxDate.setDate(today.getDate() + 10); // Max 10 days from today
    let startDate = new Date(date);
    startDate.setHours(0, 0, 0, 0);

    // Calculate days between minDate (today) and maxDate
    const daysBetween = Math.round((maxDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)) + 1; // Inclusive
    const targetDate = new Date(date);
    targetDate.setHours(0, 0, 0, 0);

    if (centerDate) {
      // Try to center the selected date (position 4 of 7, i.e., 3 days before)
      startDate.setDate(targetDate.getDate() - 3);
      // Adjust startDate to respect minDate
      if (startDate < today) {
        startDate = new Date(today);
      }
      // If targetDate is maxDate, shift startDate to include previous dates
      if (targetDate.toDateString() === maxDate.toDateString()) {
        startDate.setDate(maxDate.getDate() - 6); // Start 6 days before maxDate
        if (startDate < today) {
          startDate = new Date(today); // Ensure no past dates
        }
      }
    }

    // Generate 7 tabs, prioritizing future dates but including previous if needed
    let currentDate = new Date(startDate);
    for (let i = 0; i < 7; i++) {
      currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);
      if (currentDate >= today && currentDate <= maxDate) {
        this.dateTabs.push({
          day: currentDate.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase(),
          dateNum: currentDate.getDate().toString().padStart(2, '0'),
          month: currentDate.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
          date: currentDate
        });
      }
    }

    // If fewer than 7 tabs due to maxDate, prepend previous dates
    while (this.dateTabs.length < 7 && this.dateTabs.length > 0) {
      const firstDate = new Date(this.dateTabs[0].date);
      firstDate.setDate(firstDate.getDate() - 1);
      if (firstDate >= today) {
        this.dateTabs.unshift({
          day: firstDate.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase(),
          dateNum: firstDate.getDate().toString().padStart(2, '0'),
          month: firstDate.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
          date: firstDate
        });
      } else {
        break; // Stop if minDate is reached
      }
    }

    // If still fewer than 7 tabs, append future dates if possible
    while (this.dateTabs.length < 7) {
      const lastDate = new Date(this.dateTabs[this.dateTabs.length - 1].date);
      lastDate.setDate(lastDate.getDate() + 1);
      if (lastDate <= maxDate) {
        this.dateTabs.push({
          day: lastDate.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase(),
          dateNum: lastDate.getDate().toString().padStart(2, '0'),
          month: lastDate.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
          date: lastDate
        });
      } else {
        break; // Stop if maxDate is reached
      }
    }
  }


  submitForm() {

    if (!this.selectedDate || !this.selectedSlot || this.selectedSlot.trim() === '') {
      console.log("Invalid Data");
      this.toastr.warning('Please choose your preferred date and time for the visit.', 'Select Date & Time Slot');
      return;
    }

    if (this.scheduleVisitData && this.scheduleVisitData !== null) {

      let data: PropertyVisitUpdateRequestDTO = {
        visitId: this.scheduleVisitData.visitId,
        masterId: this.propertyId,
        masterType: 'Property',
        visitorUserId: this.User.userId,
        scheduledDate: new Date(
          Date.UTC(
            this.selectedDate.getFullYear(),
            this.selectedDate.getMonth(),
            this.selectedDate.getDate()
          )
        ),
        timeSlot: this.selectedSlot!,
        status: 'Re-Scheduled',
        notes: '',
        otherDetails1: '',
        otherDetails2: '',
        otherDetails3: '',
        otherDetails4: '',
        otherDetails5: '',
        otherDetails6: '',
        isActive: 1,
        actionUser: this.User.userId.toString()
      }

      this.propertyVisitService.PropertyVist_Update(data).subscribe((res) => {
        console.log(res);
        this.activeModal.close(res);
        this.showSuccessModal();
      })

    } else {

      let data: PropertyVisitCreateRequestDTO = {
        masterId: this.propertyId,
        masterType: 'Property',
        visitorUserId: this.User.userId,
        scheduledDate: new Date(
          Date.UTC(
            this.selectedDate.getFullYear(),
            this.selectedDate.getMonth(),
            this.selectedDate.getDate()
          )
        ),
        timeSlot: this.selectedSlot!,
        status: 'Scheduled',
        notes: '',
        actionUser: this.User.userId.toString()
      }

      this.propertyVisitService.PropertyVist_Create(data).subscribe((res) => {
        console.log(res);
        this.activeModal.close(res);
        this.showSuccessModal();
      })
    }

  }

  selectDate(date: Date) {
    this.selectedDate = date;
    this.selectedSlot = null;
    console.log('Selected date:', date.toDateString());
  }

  selectSlot(slot: string) {
    this.selectedSlot = slot;
  }


  openDatePicker() {
    const inputElement = this.dateInput.nativeElement;
    // Programmatically open the date picker
    inputElement.showPicker(); // Modern browsers support this
    inputElement.focus(); // Fallback to ensure the picker opens
  }

  onDateChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const selected = new Date(inputElement.value);
    if (selected) {
      this.selectedDate = new Date(selected);
      this.selectedSlot = null;
      // Regenerate date tabs with the selected date in the middle
      this.generateDateTabs(selected, true);
      console.log('Selected date:', selected.toDateString());
    }
  }


  private showSuccessModal(): void {
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: 'long', // for full month name like "July"
      year: 'numeric'
    }).format(this.selectedDate);

    Swal.fire({
      icon: 'success',
      title: 'Visit Booked!',
      html: `Your visit is scheduled on <b>${formattedDate}</b> at <b>${this.selectedSlot}</b>.`,
      timer: 3500,
      confirmButtonText: 'Great!',
      customClass: {
        popup: 'swal2-border-radius'
      }
    });
  }



}
